__turbopack_context__.v({
  "Mui-focused": "I4jiqG_Mui-focused",
  "Mui-primary": "I4jiqG_Mui-primary",
  "Mui-secondary": "I4jiqG_Mui-secondary",
  "characterCount": "I4jiqG_characterCount",
  "characterCountDisabled": "I4jiqG_characterCountDisabled",
  "container": "I4jiqG_container",
  "errorText": "I4jiqG_errorText",
});
